<template>
  <div class="container">
    <div class="row justify-content-center">
      <v-card class="col-12">
        <v-toolbar color="#2A3F54" dark v-if="tituloform">
          <v-toolbar-title>{{tituloform}}</v-toolbar-title>
        </v-toolbar>

        <slot></slot>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["titulo"],
  data: () => ({
    tituloform: String
  }),
  mounted() {
    this.tituloform = this.titulo;
  }
};
</script>
